import { showToast } from "../../../utils/toastModal";

export const copyUrl = (docId) => {
  navigator.clipboard.writeText(
    `https://a2apay.co.uk/pis-refundrequest?id=${docId}`
  );
  showToast(true, "Link copied to clipboard");
};
